import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import ApiService from 'services/ApiService';
import { repeatEffect, settingsConfig } from 'utils/commonFunc';
import { ResponsiveBar } from '@nivo/bar';

const RoadDayDataTotalContext = createContext(null);

export function SwItsRoadDayDataTotalProvider({ children }) {
    const [currentData, setCurrentData] = useState();

    useEffect(() => {
        return repeatEffect(async () => {
            const response = await ApiService.get("newdashboard/trfsfty/GetRoadDayData");
            if (response.status === 200) {
                const data = response.data;

                setCurrentData({
                    updateTime: data.updateTime,
                    data: data
                });
            }
        }, settingsConfig().contentUpdateDelaySec);
    }, []);

    return (
        <RoadDayDataTotalContext.Provider value={currentData}>
            {children}
        </RoadDayDataTotalContext.Provider>
    );
}

// export function SwItsRoadDayDataTotalChart() {
//     const currentData = useContext(RoadDayDataTotalContext);
//     const [chartData, setChartData] = useState([]);
//     const [tickValues, setTickValues] = useState([]);

//     // 날짜 범위 생성 함수 (1월 1일 ~ 오늘)
//     const generateDateRange = (startDate, endDate) => {
//         const dateArray = [];
//         let current = new Date(startDate);
//         while (current <= endDate) {
//             dateArray.push(current.toISOString().slice(0, 10));
//             current.setDate(current.getDate() + 1);
//         }
//         return dateArray;
//     };

//     // 변환 함수: 누락된 날짜도 채우기
//     const transformData = (data) => {
//         const dataMap = {};
//         data.forEach(entry => {
//             const wetCount = entry.rows.find(row => row.statCd === '003')?.count || 0;
//             const icyCount = entry.rows.find(row => row.statCd === '006')?.count || 0;
//             dataMap[entry.time] = { wet: wetCount, icy: icyCount };
//         });

//         const today = new Date();
//         today.setDate(today.getDate() - 0);
//         const startOfYear = new Date(today.getFullYear(), 0, 2);
//         const fullDateRange = generateDateRange(startOfYear, today);
//         return fullDateRange.map(date => ({
//             date,
//             wet: dataMap[date]?.wet || 0,
//             icy: dataMap[date]?.icy || 0,
//         }));
//     };

//     useEffect(() => {
//         if (currentData) {
//             const transformed = transformData(currentData.data);
//             setChartData(transformed);

//             //  const allDates = transformed.map(d => d.date);
//             // const monthlyTicks = allDates.filter(d => d.endsWith('-01'));
//             const monthlyTicks = transformed
//                 .map(d => d.date)
//                 .filter(date => date.endsWith('-01'));

//             setTickValues(monthlyTicks);
//             // setTickValues([allDates[0], ...monthlyTicks, allDates[allDates.length - 1]]);
//         }
//     }, [currentData]);
//     return (
//         <div style={{ height: '580px' }}>
//             <ResponsiveBar
//                 data={chartData}
//                 keys={['wet', 'icy']}
//                 indexBy="date"
//                 margin={{ top: 60, right: 20, bottom: 60, left: 50 }}
//                 padding={0}
//                 maxValue={24}
//                 tooltip={() => null}
//                 groupMode="grouped"
//                 colors={({ id }) => id === 'wet' ? '#FFC414' : '#46B1FE'}
//                 borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
//                 axisBottom={{
//                     tickValues: tickValues,
//                     tickRotation: 0,
//                     format: (value) => {
//                         const d = new Date(value);
//                         return `${d.getMonth() + 1}/${d.getDate()}`;
//                     },
//                     legendPosition: 'middle',
//                     legendOffset: 120,
//                     tickSize: 4,
//                     tickPadding: 10,
//                 }}
//                 axisLeft={{
//                     tickValues: [0, 6, 12, 18, 24],
//                     //  legend: '건수',
//                     legendPosition: 'middle',
//                     legendOffset: 120
//                 }}
//                 enableGridX={false}
//                 enableGridY={true}
//                 gridYValues={[0, 6, 12, 18, 24]}
//                 theme={{
//                     grid: {
//                         line: {
//                             stroke: '#ffffff',
//                             strokeWidth: 0.5,
//                         },
//                     },
//                     axis: {
//                         ticks: {
//                             line: {
//                                 stroke: '#ffffff',
//                             },
//                             text: {
//                                 fill: '#ffffff',
//                                 fontSize: 30,
//                             },
//                         },
//                         legend: {
//                             text: {
//                                 fill: '#ffffff',
//                                 fontSize: 30,
//                                 fontWeight: 700,
//                             },
//                         },
//                     },
//                     legends: {
//                         text: {
//                             fill: '#ffffff',
//                             fontSize: 20,
//                         },
//                     },
//                 }}
//                 labelSkipWidth={6}
//                 labelSkipHeight={6}
//                 labelTextColor="#fff"
//                 legends={[
//                     {
//                         dataFrom: 'keys',
//                         anchor: 'top-right',
//                         direction: 'row',
//                         justify: false,
//                         translateX: 0,
//                         translateY: -60,
//                         itemsSpacing: 20,
//                         itemWidth: 100,
//                         itemHeight: 20,
//                         itemDirection: 'left-to-right',
//                         symbolSize: 20,
//                         symbolShape: 'square',
//                         data: [
//                             { id: 'wet', label: 'WET', color: '#FFC414' },
//                             { id: 'icy', label: 'ICE', color: '#46B1FE' },
//                         ],
//                     },
//                 ]}
//                 animate={true}
//                 motionConfig="wobbly"
//                 role="application"
//                 ariaLabel="Wet and Icy Time Daily Chart"
//             />
//         </div>
//     );
// }


export function SwItsRoadDayDataTotalChart() {
    const currentData = useContext(RoadDayDataTotalContext);
    const [chartData, setChartData] = useState([]);
    const [tickValues, setTickValues] = useState([]);

    // 날짜 범위 생성 함수 (1월 1일 ~ 오늘)
    // const generateDateRange = (startDate, endDate) => {
    //     const dateArray = [];
    //     let current = new Date(startDate);
    //     while (current <= endDate) {
    //         dateArray.push(current.toISOString().slice(0, 10));
    //         current.setDate(current.getDate() + 1);
    //     }
    //     return dateArray;
    // };

    // // 변환 함수: 누락된 날짜도 채우기
    // const transformData = (data) => {
    //     const dataMap = {};
    //     data.forEach(entry => {
    //         const wetCount = entry.rows.find(row => row.statCd === '003')?.count || 0;
    //         const icyCount = entry.rows.find(row => row.statCd === '006')?.count || 0;
    //         dataMap[entry.time] = { wet: wetCount, icy: icyCount };
    //     });

    //     const today = new Date();
    //     today.setDate(today.getDate() - 0);
    //     const startOfYear = new Date(today.getFullYear(), 0, 2);
    //     const fullDateRange = generateDateRange(startOfYear, today);
    //     return fullDateRange.map(date => ({
    //         date,
    //         wet: dataMap[date]?.wet || 0,
    //         icy: dataMap[date]?.icy || 0,
    //     }));
    // };

    // useEffect(() => {
    //     if (currentData) {
    //         const transformed = transformData(currentData.data);
    //         setChartData(transformed);

    //         //  const allDates = transformed.map(d => d.date);
    //         // const monthlyTicks = allDates.filter(d => d.endsWith('-01'));
    //         const monthlyTicks = transformed
    //             .map(d => d.date)
    //             .filter(date => date.endsWith('-01'));

    //         setTickValues(monthlyTicks);
    //         // setTickValues([allDates[0], ...monthlyTicks, allDates[allDates.length - 1]]);
    //     }
    // }, [currentData]);
    const generateDateRange = (startDate, endDate) => {
        const dateArray = [];
        let current = new Date(startDate);
        while (current <= endDate) {
            dateArray.push(current.toISOString().slice(0, 10));
            current.setDate(current.getDate() + 1);
        }
        return dateArray;
    };

    // 변환 함수: 최근 12개월 데이터만
    const transformData = (data) => {
        const dataMap = {};
        data.forEach(entry => {
            const wetCount = entry.rows.find(row => row.statCd === '003')?.count || 0;
            const icyCount = entry.rows.find(row => row.statCd === '006')?.count || 0;
            dataMap[entry.time] = { wet: wetCount, icy: icyCount };
        });

        const today = new Date();
        const twelveMonthsAgo = new Date(today);
        twelveMonthsAgo.setMonth(today.getMonth() - 12);

        const fullDateRange = generateDateRange(twelveMonthsAgo, today);
        return fullDateRange.map(date => ({
            date,
            wet: dataMap[date]?.wet || 0,
            icy: dataMap[date]?.icy || 0,
        }));
    };

    useEffect(() => {
        if (currentData) {
            const transformed = transformData(currentData.data);
            setChartData(transformed);

            const allDates = transformed.map(d => d.date);
            const monthlyTicks = allDates.filter(date => date.endsWith('-01'));
            const yearChangeDates = allDates.filter(date => date.match(/-01-01$/));

            const combinedTicks = [...new Set([...monthlyTicks, ...yearChangeDates])].sort();

            setTickValues(combinedTicks);
        }
    }, [currentData]);
    return (
        <div style={{ height: '580px' }}>
            <ResponsiveBar
                data={chartData}
                keys={['wet', 'icy']}
                indexBy="date"
                margin={{ top: 60, right: 20, bottom: 60, left: 50 }}
                padding={0}
                maxValue={24}
                tooltip={() => null}
                groupMode="grouped"
                colors={({ id }) => id === 'wet' ? '#FFC414' : '#46B1FE'}
                borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                axisBottom={{
                    tickValues: tickValues,
                    tickRotation: 0,
                    format: (value) => {
                        const d = new Date(value);
                        if (d.getMonth() === 0 && d.getDate() === 1) {
                            return ` ${d.getFullYear()}/1/1`;
                        }
                        return `${d.getMonth() + 1}/${d.getDate()}`;
                    },
                    legendPosition: 'middle',
                    legendOffset: 120,
                    tickSize: 4,
                    tickPadding: 10,
                }}
                axisLeft={{
                    tickValues: [0, 6, 12, 18, 24],
                    //  legend: '건수',
                    legendPosition: 'middle',
                    legendOffset: 120
                }}
                enableGridX={false}
                enableGridY={true}
                gridYValues={[0, 6, 12, 18, 24]}
                theme={{
                    grid: {
                        line: {
                            stroke: '#ffffff',
                            strokeWidth: 0.5,
                        },
                    },
                    axis: {
                        ticks: {
                            line: {
                                stroke: '#ffffff',
                            },
                            text: {
                                fill: '#ffffff',
                                fontSize: 30,
                            },
                        },
                        legend: {
                            text: {
                                fill: '#ffffff',
                                fontSize: 30,
                                fontWeight: 700,
                            },
                        },
                    },
                    legends: {
                        text: {
                            fill: '#ffffff',
                            fontSize: 20,
                        },
                    },
                }}
                labelSkipWidth={6}
                labelSkipHeight={6}
                labelTextColor="#fff"
                legends={[
                    {
                        dataFrom: 'keys',
                        anchor: 'top-right',
                        direction: 'row',
                        justify: false,
                        translateX: 0,
                        translateY: -60,
                        itemsSpacing: 20,
                        itemWidth: 100,
                        itemHeight: 20,
                        itemDirection: 'left-to-right',
                        symbolSize: 20,
                        symbolShape: 'square',
                        data: [
                            { id: 'wet', label: 'WET', color: '#FFC414' },
                            { id: 'icy', label: 'ICE', color: '#46B1FE' },
                        ],
                    },
                ]}
                animate={true}
                motionConfig="wobbly"
                role="application"
                ariaLabel="Wet and Icy Time Daily Chart"
            />
        </div>
    );
}